<script>
  import { onMount } from 'svelte'
  import { Map, Marker, controls } from '@beyonk/svelte-mapbox'
  import { Link } from 'svelte-routing'
  import Markdown from 'svelte-markdown'
  import { pinsStore } from '../../scripts/pins'
  import { getAllWorks } from '../../scripts/works'
  import Source from '../common/PictureSource.svelte';

  let Lng = -3.4481452250061073
  let Lat = 54.750766895206844
  

  const { NavigationControl, ScaleControl } = controls
  let map
  let bounds = []
  
  $: if(map && bounds.length > 0){map.fitBounds(bounds, {
        padding: 25
        }); }
  
    onMount(async() =>{
      await $pinsStore
        .then(r => 
          bounds = r.map(
              pin=>[pin.coordinates.longitude, pin.coordinates.latitude]
          )
        )   
    })
  
</script>

<style>
    section {
        height: 70vh;
        margin: 2rem auto;
        
    }
    :global(.mapboxgl-marker) {
      cursor: pointer;
    }
    .content {
      max-width: 80vw;
      padding: 12px;

    }
    .columns {
      display: flex;
      flex-direction: row-reverse;
    }
    .is-narrow { flex: none;}
    .location-image {
      width: 150px;
      height: 150px;
      object-fit: cover;
      object-position: center;
    }
    img {
      border-radius: .5rem;
    }
    img.thumb {
      height:60px; 
      width:60px; 
      cursor:pointer;
      object-fit: cover;
      object-position: center;
      margin: .1rem;
    }
    @media(min-width:769px){ 
      .content {
        max-width: 50vw;
      }
      .location-image {
        width: 200px;
        height: 200px;
      }
    }
    @media(min-width:1150px){ 
      .content {
        max-width: 40vw;
      }
    }
    @media(min-width:1300px){ 
      .content {
        max-width: 30vw;
      }
    }

</style>
<section>
<Map bind:this={map}
  accessToken="pk.eyJ1IjoiY3JhaWctY2hhbWJlcmxhaW4iLCJhIjoiY2ttbTByYmx3MWdiZzJvazV0Zm55ZHBpciJ9.pmN8DDzUEXNr8JH1gXN7Cg" 
  options={{center: [Lng,Lat]}} 
  >  <NavigationControl />
    <ScaleControl />
      {#await $pinsStore then pins}
        {#each pins as pin}
          <Marker lat={pin.coordinates.latitude} lng={pin.coordinates.longitude}  popupClassName="popup-wrapper" popupOptions="{{'maxWidth':'none'}}" >
            <div class="content" slot="popup">
                <div class="columns is-vcentered">
                  <div class="column">
                    <h3>{pin.name}</h3>
                    <Markdown source={pin.description} />
                    
                  </div>
                  {#if pin.images.length > 0}
                  <div class="column is-narrow">
                    <img class="location-image" src="{ pin.images[0].url}" alt="{pin.name}"/>
                  </div>
                  {/if}
                </div>
                {#await getAllWorks() then works}
                    <h4>Featured Work</h4>
                    {#each works as work}
                      {#if work.survey.location.id == pin.id}
                        <Link to='/product/{work.id}'>
                          <picture class="thumb" >
                              <Source fit="crop" width=60 height=60 image={work.images[0].url} /> 
                              <img class="thumb" src="{ work.images[0].url}?fit=crop&w=60&h=60&fm=jpg" alt="{work.title}" title="{work.survey.subAtomicDate} - {work.title}"/>
                          </picture>
                          
                        </Link>
                      {/if}
                    {/each}
                {/await}
            </div> 
          </Marker>
        {/each}
      {/await}
</Map>
</section>